export const PAGE_SIZE = 50;

export const HIDEABLE_COLUMN_IDS = [
    'strategyName',
    'completedAt',
    'duration',
    'horizonSeconds',
    'totalEntries',
    'totalEntities',
    'avgProfitPercent',
    'medianProfitPercent',
    'avgAlphaPercent',
    'winRate',
    'winRateVsSpy',
    'profitFactor',
    'coefficientOfVariation',
    'optionAvgProfitPercent',
    'optionMedianProfitPercent',
    'optionWinRate'
] as const;

export type HideableColumnId = (typeof HIDEABLE_COLUMN_IDS)[number];

export const COLUMN_LABELS: Record<HideableColumnId, string> = {
    strategyName: 'Strategy',
    completedAt: 'Completed',
    duration: 'Duration',
    horizonSeconds: 'Horizon',
    totalEntries: 'Entries',
    totalEntities: 'Entities',
    avgProfitPercent: 'Avg Profit',
    medianProfitPercent: 'Median Profit',
    avgAlphaPercent: 'Alpha',
    winRate: 'Win Rate',
    winRateVsSpy: 'Beat SPY',
    profitFactor: 'Profit Factor',
    coefficientOfVariation: 'CV',
    optionAvgProfitPercent: 'Option Avg',
    optionMedianProfitPercent: 'Option Median',
    optionWinRate: 'Option Win'
};

export const COLUMN_PRESETS: { id: string; label: string; visible: HideableColumnId[] }[] = [
    {
        id: 'all',
        label: 'All',
        visible: [...HIDEABLE_COLUMN_IDS]
    },
    {
        id: 'profit',
        label: 'Profitability',
        visible: ['duration', 'horizonSeconds', 'totalEntries', 'avgProfitPercent', 'medianProfitPercent', 'winRate', 'profitFactor']
    },
    {
        id: 'risk',
        label: 'Risk',
        visible: ['duration', 'horizonSeconds', 'totalEntries', 'avgProfitPercent', 'winRate', 'profitFactor', 'coefficientOfVariation']
    },
    {
        id: 'bench',
        label: 'Benchmark',
        visible: ['duration', 'horizonSeconds', 'totalEntries', 'avgProfitPercent', 'avgAlphaPercent', 'winRate', 'winRateVsSpy']
    },
    {
        id: 'options',
        label: 'Options',
        visible: [
            'duration',
            'horizonSeconds',
            'totalEntries',
            'avgProfitPercent',
            'optionAvgProfitPercent',
            'optionMedianProfitPercent',
            'optionWinRate'
        ]
    }
];

export type StagePresenceFilter = 'all' | 'yes' | 'no';

export const STAGE_FILTER_OPTIONS: { value: StagePresenceFilter; label: string }[] = [
    { value: 'all', label: 'All' },
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' }
];

export const durationValues = ['1m', '3m', '5m', '15m', '30m', '60m', '120m', '180m', '240m', '1d', '1w', '1mo'] as const;

export type CompareDuration = (typeof durationValues)[number];
